import React, { Component } from "react"
import { Button } from "semantic-ui-react"
import { translate } from "react-translate"
import "./BtnAppliquer.css"

class BtnAppliquer extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }
  render() {
    let { t } = this.props

    return <Button id="bouttonAppliquer">{t("btn_appliquer")}</Button>
  }
}
export default translate("ProEnteteBtnApply")(BtnAppliquer)



// WEBPACK FOOTER //
// ./src/components/Pro/Entete/BtnAppliquer.js